<h2 mat-dialog-title>Agregar magnitudes basado en otro modelo</h2>
<div mat-dialog-content>
  <p>Seleccione un modelo para importar sus magnitudes:</p>
  <mat-form-field class="w-full">
    <mat-label>Modelo</mat-label>
    <input type="text"
           placeholder="Buscar por marca o modelo"
           aria-label="Modelo"
           matInput
           [formControl]="modelCtrl"
           [matAutocomplete]="auto">
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
      <mat-option *ngFor="let model of filteredModels | async" [value]="model">
        {{model.name}} ({{model.brand?.name}})
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
</div>
<div mat-dialog-actions class="flex justify-end gap-2">
  <button mat-button (click)="cancel()">Cancelar</button>
  <button mat-button color="primary" (click)="selectModel()" [disabled]="!modelCtrl.value">Aceptar</button>
</div>

